import React from 'react'

import ObjectDataGrid from 'features/admin/datagrid/ObjectDataGrid'
type AppSettingsModalDataGridProps = { objectId: string }
export const AppSettingsModalDataGrid: React.VFC<AppSettingsModalDataGridProps> = (props) => {
    return <ObjectDataGrid isActive={true} {...props} />
}

export default AppSettingsModalDataGrid
